/**@jsx jsx */
import { Box, jsx } from 'theme-ui'
const Spacer = ({ amount }) => {
  return <Box sx={{ marginTop: amount }} />
}

export default Spacer
